import {
  Component,
  Input,
  Output,
  EventEmitter,
  signal,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export interface AzTab {
  label: string;
  id: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-az-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './az-tabs.component.html',
  styleUrl: './az-tabs.component.scss',
})
export class AzTabsComponent implements OnInit, OnChanges {
  @Input() tabs: AzTab[] = [];
  @Input() set activeTabId(value: string) {
    if (value) {
      this.activeTab.set(value);
    }
  }

  @Output() activeTabChange = new EventEmitter<string>();

  activeTab = signal<string>('');

  ngOnInit(): void {
    this.setDefaultActiveTab();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabs'] && this.tabs.length > 0 && !this.activeTab()) {
      this.setDefaultActiveTab();
    }
  }

  private setDefaultActiveTab(): void {
    if (this.tabs.length > 0 && !this.activeTab()) {
      const firstEnabledTab = this.tabs.find((tab) => !tab.disabled);
      if (firstEnabledTab) {
        this.activeTab.set(firstEnabledTab.id);
      }
    }
  }

  selectTab(tabId: string): void {
    const tab = this.tabs.find((t) => t.id === tabId);
    if (tab && !tab.disabled) {
      this.activeTab.set(tabId);
      this.activeTabChange.emit(tabId);
    }
  }

  isActive(tabId: string): boolean {
    return this.activeTab() === tabId;
  }
}
